import { useIonAlert } from '@ionic/react';

export function useDeleteAddress() {
  const [modal] = useIonAlert();

  const showDeleteAddress = () => {
    return new Promise((resolve) => {
      modal({
        cssClass: ['elanco--alert-confirm elanco--alert-delete'],
        message: `<h4>Are you sure you want to delete your preferred shipping address</h4>`,
        buttons: [
          {
            text: 'Delete',
            handler: () => resolve(true),
          },
          {
            text: 'Close',
            cssClass: 'button-outline',
            handler: () => resolve(false),
          },
        ],
        onDidDismiss: () => resolve(false),
      });
    });
  };

  return {
    showDeleteAddress,
  };
}
